// extracted by mini-css-extract-plugin
export default {"itemContainer":"legendItem_itemContainer__6ueuv","itemLanguage":"legendItem_itemLanguage__cqCIn","itemCount":"legendItem_itemCount__8e1EC","Compact":"legendItem_Compact__kcF9F"};